import date from './date'
import currencyFormatter from './currency-formater'
import loadScript from './load-script'
import smoothScrollTo from './smooth-scroll-to'
import _ from 'lodash'

// 如果keywords为空，也算匹配 (keywords可以为多个，通过空格分开，如果是多个，那么，要全部匹配才算成功)
function checkKeywordsMatch (text, keywords) {
  if (keywords) {
    text = (text || '').toUpperCase()
    keywords = (keywords || '').toUpperCase()
    let words = _.filter((keywords || '').split(/\s+/), e => e)
    if (words.length > 0) {
      for (let item of words) {
        if (text.indexOf(item) === -1) return false
      }
    }
  }
  return true
}

function getBrowser () {
  let ua = navigator.userAgent
  let tem
  let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || []
    return {name: 'IE', version: (tem[1] || '')}
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\bOPR|Edge\/(\d+)/)
    if (tem) {
      return {name: 'Opera', version: tem[1]}
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?']
  if ((tem = ua.match(/version\/(\d+)/i))) {
    M.splice(1, 1, tem[1])
  }
  return {
    name: M[0],
    version: M[1]
  }
}

let _isSupportWebP
function isSupportWebP () {
  if (_isSupportWebP === undefined) {
    _isSupportWebP = document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0
  }
  return _isSupportWebP
}

let scrollWidth = null
function getScrollWidth () {
  if (scrollWidth) {
    return scrollWidth
  }
  let noScroll
  let scroll
  let oDiv = document.createElement('DIV')
  oDiv.style.cssText = 'position:absolute; top:-1000px; width:100px; height:100px; overflow:hidden;'
  noScroll = document.body.appendChild(oDiv).clientWidth
  oDiv.style.overflowY = 'scroll'
  scroll = oDiv.clientWidth
  document.body.removeChild(oDiv)
  scrollWidth = noScroll - scroll
  return scrollWidth
}

function getLocationOrigin () {
  return window.location.origin || window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
}

function findValidScrollParent (curEl, direction) {
  let pEl = curEl && curEl.parentNode
  if (curEl && pEl) {
    let finalStyle = pEl.currentStyle ? pEl.currentStyle : document.defaultView.getComputedStyle(pEl, null)
    let vals = ['auto', 'scroll']
    if (vals.indexOf(finalStyle.overflow) > -1 || vals.indexOf(finalStyle['overflow' + direction === 'vertical' ? 'Y' : 'X']) > -1) {
      return pEl
    } else {
      return findValidScrollParent(pEl, direction)
    }
  } else {
    return null
  }
}

// 父级元素必须有 overflow 设置
function scrollIntoView (el, offset = 0, direction = 'vertical') {
  let prop = direction === 'vertical' ? 'Top' : 'Left'
  let pEl = findValidScrollParent(el, direction)
  if (pEl) {
    pEl['scroll' + prop] = el['offset' + prop] + offset
  }
}

// 仅比较有值的属性(非null, undefined, 空字符串)
function isObjectEqual (obj1, obj2) {
  if (obj1) {
    obj1 = _.clone(obj1)
    for (let key in obj1) {
      if (obj1.hasOwnProperty(key) && (_.isNil(obj1[key]) || obj1[key] === '')) {
        delete obj1[key]
      }
    }
  }
  if (obj2) {
    obj2 = _.clone(obj2)
    for (let key in obj2) {
      if (obj2.hasOwnProperty(key) && (_.isNil(obj2[key]) || obj2[key] === '')) {
        delete obj2[key]
      }
    }
  }
  return _.isEqual(obj1, obj2)
}

function isObjectEmpty (obj) {
  if (!obj) return true
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (!_.isNil(obj[key])) {
        return false
      }
    }
  }
  return true
}

let suffixes = ['png', 'jpg', 'gif']
// 检查路径是否是图片
let checkPathIsImage = (path) => {
  let parts = path.split('.')
  let suffix = parts[parts.length - 1].toLowerCase()
  return suffixes.indexOf(suffix) > -1
}

let utils = {
  loadScript,
  toDate: date.toDate,
  dateFormat: date.dateFormat,
  formatPhoneNumber (number, splitChar) {
    if (!number) return '--'
    if (number.length !== 11) return number
    splitChar = splitChar || ' '
    return number.slice(0, 3) + splitChar + number.slice(3, 7) + splitChar + number.slice(7, 11)
  },
  formatTime (ticks, en) {
    let allSecs = Math.floor(ticks / 1000)
    let s = allSecs % 60
    let m = s && Math.floor(allSecs / 60) % 60
    let h = 0
    let d = 0
    if (en) {
      h = m && Math.floor(allSecs / 60 / 60)
      return `${_.padStart(h, 2, '0')}:${_.padStart(m, 2, '0')}:${_.padStart(s, 2, '0')}`
    } else {
      h = m && Math.floor(allSecs / 60 / 60) % 24
      d = h && Math.floor(allSecs / 60 / 60 / 24)
      return `${d ? d + '天' : ''}${h ? h + '时' : ''}${m ? m + '分' : ''}${s ? s + '秒' : ''}`
    }
  },
  currencyFormatter,
  getBrowser,
  smoothScrollTo,
  isObjectEqual,
  isObjectEmpty,
  scrollIntoView,
  getLocationOrigin,
  getScrollWidth,
  isSupportWebP,
  checkKeywordsMatch,
  getAllStyle () {
    let style = ''
    for (let child of document.head.children) {
      if (child.tagName === 'STYLE') {
        style += child.innerText
      }
    }
    return style
  },
  checkPathIsImage
}

export default utils
